import { Link } from "react-router-dom";
import React from "react";
import usePageTitle from "common/usePageTitle";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import { Container } from "react-bootstrap";
import { BsCheckCircleFill } from "react-icons/bs";
import "./MaturaApplicationSentPage.css";

function MaturaApplicationSentPage() {
  usePageTitle("Prijava uspješno poslana");

  return (
    <>
      <LumenNavbar />
      <Container>
        <div className="application-sent-page">
          <div className="application-sent-card">
            <div className="application-sent-icon">
              <BsCheckCircleFill />
            </div>
            <h1>Prijava uspješno poslana!</h1>
            <p>
              Zahvaljujemo na prijavi. Ubrzo ćemo Vas kontaktirati s daljnjim
              informacijama.
            </p>
            <Link to="/" className="application-sent-button">
              Povratak na naslovnu
            </Link>
          </div>
        </div>
      </Container>
      <NewFooter />
    </>
  );
}

export default MaturaApplicationSentPage;
